import { type LanguageKey } from '@/domain/locale'

/**
 * Gets GMaps URL from address
 */
export const getGoogleMapsUrl = (languageKey: LanguageKey, address?: string) => {
  if (!address) return ''

  return `http://maps.google.com/?q=${encodeURIComponent(address)}&hl=${languageKey}`
}
